export const NEW_PASSWORD_REGEX = 'matchRegexp:^(?=.*[0-9])(?=.*[a-zA-Z]).{6,20}$';
export const NEW_PASSWORD_REGEX_TIP = 'Password should contain at least 1 digit and 1 English letter, and be 6-20 characters long.';